import React from 'react';
import { Star as LucideStar, LucideProps } from 'lucide-react';

export const Star = (props: LucideProps) => <LucideStar {...props} />;

export default Star;
